export default {
  en: {
    'pages.filing.log-page.title': 'Error logs',
    'pages.filing.log-page.tab.edited': 'Edited',
    'pages.filing.log-page.tab.deleted': 'Deleted',
    'pages.filing.log-page.tab.ignored': 'Ignored',
  },
};
